export default {"src":"/_next/static/media/chocolate.34429a2d.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};